const EDITABLE_TAGS = ['INPUT', 'TEXTAREA']

const isEditableElementFocused = () => {
  const { activeElement } = document
  if (!activeElement) return false
  return EDITABLE_TAGS.includes(activeElement.tagName) || activeElement.isContentEditable
}

const watchVisibility = (onKeyboardShow, onKeyboardHide) => {
  window.addEventListener('keyboardWillHide', () => {
    onKeyboardHide()
  })
  window.addEventListener('keyboardWillShow', () => {
    onKeyboardShow()
  })

  // O cordova-plugin-ionic-keyboard pode perder o pareamento show/hide quando a
  // UI nativa de print/compartilhamento mexe no foco do campo. Sem o hide, o
  // estado fica travado em "teclado aberto" e o HideOnKeyboardUp mantém a
  // navegação desmontada até o app reiniciar. Quando o foco sai de um campo
  // editável e nada mais assume, forçamos o estado de volta para "fechado".
  if (window.cordova) {
    document.addEventListener('focusout', () => {
      // Adiado um tick porque o focusout do campo antigo acontece antes de o
      // novo campo virar o activeElement — sem isso, trocar de campo dentro do
      // mesmo formulário dispararia um hide indevido.
      setTimeout(() => {
        if (!isEditableElementFocused()) onKeyboardHide()
      }, 0)
    })
  }
}

export default { watchVisibility }
